// ServiceCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

const ServiceCard = ({ title, description, imageUrl, link, icon: Icon }) => {
  return (
    <div className="service-card">
      <img src={imageUrl} alt={title} className="service-image" />
      <div className="service-content">
        {Icon && (
          <div className="service-icon-badge">
            <Icon className="service-icon" aria-hidden="true" />
          </div>
        )}
        <h3 className="service-title">{title}</h3>
        <p className="service-description">{description}</p>
        <Link to={link} className="read-more-button">Read More</Link>
      </div>
    </div>
  );
};

export default ServiceCard;
